import { useState } from "react";
import { useAwaitingBonus } from "./useAwaitingBonus";
import { BonusReceiptDialog } from "./BonusReceiptDialog";

// بوابة عامة: تعرض نافذة تأكيد الاستلام تلقائياً في أي شاشة عند وجود مكافأة معلّقة.
export const BonusReceiptGate = () => {
  const { awaiting, reload } = useAwaitingBonus();
  const [skipped, setSkipped] = useState([]);
  const bonus = awaiting.find((b) => !skipped.includes(b.bonus_id));
  if (!bonus) return null;
  return (
    <BonusReceiptDialog
      bonus={bonus}
      onDone={() => {
        setSkipped((prev) => [...prev, bonus.bonus_id]);
        reload();
      }}
      onLater={() => setSkipped((prev) => [...prev, bonus.bonus_id])}
    />
  );
};
